import { config } from "config";
import {DocumentState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";

const default_page_size = config.PAGE_SIZE;

const initialState: DocumentState = {
	documents: [],
	document: null,
	loading: true,
  filters: { page: 1, page_size: default_page_size },
  count: 0,
  refresh: 0,
  refreshLoader: false,
  current_filters: { },
};

export const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    resetFilters: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
    },
    setCompanyDocs: (state, action) => {
      state.document = action.payload;
    },
    updateCompanyDocInList: (state, action) => {
      const { document } = action.payload;
      const nid = document?._id != null ? String(document._id) : "";
      state.documents = state.documents.map((doc: any) =>
        String(doc._id) === nid ? { ...doc, ...document } : doc
      );
      state.document = document; 
    },
    
    addCompanyDocs: (state, action) => {
      state.documents.unshift(action.payload);
    },
    setCompanyDocuments: (state, action) => {
      const { documents, count } = action.payload;
      let options: SelectOption[] = [];
      documents.forEach(({ _id, name,email,position }: any) =>
        options.push({ value: _id, label: name })
      );
      state.documents = documents;
      state.count = count;
      state.refreshLoader = false;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters.page = action.payload;
    },
    refresh: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    deleteCompanyDocument: (state, action) => {
      const id = action.payload;
      state.documents = state.documents.filter(
        ({ _id }) => id !== _id
      );
    },
  },
});

const documentsReducer = documentsSlice.reducer;

export const documentsActions = documentsSlice.actions;
export default documentsReducer;
